import { Form } from './form.model';
import { FormLayout } from './form-layout.model';
import { FormField } from './form-field.model';
import { FormFieldExpression } from '../field-conditional-logic/form-field-expression.model';

export class SiteHomePage extends Form {
    // Properties.
    public isActive: boolean;

    public showPublishFolderButton: boolean;
    public showSubscribeToFolderButton: boolean;

    // Constructor.
    public constructor(homePageToCopy: SiteHomePage = null) {
        super(homePageToCopy);
    }

    // Static method.
    public static createFromForm(formToCopy: Form) {
        let homePage: SiteHomePage = new SiteHomePage();

        homePage.id = formToCopy.id;

        homePage.dataCollectionId = formToCopy.dataCollectionId;

        homePage.name = formToCopy.name;
        homePage.description = formToCopy.description;

        homePage.helpText = formToCopy.helpText;
        homePage.helpTextFormat = formToCopy.helpTextFormat;

        homePage.currentUserCanBuildForms = formToCopy.currentUserCanBuildForms;

        homePage.enableCellSelection = formToCopy.enableCellSelection;


        // Copy object properties.
        homePage.formLayout = null;
        if (formToCopy.formLayout != null) {
            let layoutCopy: FormLayout = <FormLayout>formToCopy.formLayout.clone();

            homePage.formLayout = layoutCopy;
        }

        homePage.formFields = [];
        if (formToCopy.formFields && (formToCopy.formFields.length > 0)) {
            for (let iFF: number = 0; iFF < formToCopy.formFields.length; iFF++) {
                let formFieldToCopy: FormField = formToCopy.formFields[iFF];

                let formFieldCopy: FormField = <FormField>formFieldToCopy.clone();
                homePage.formFields.push(formFieldCopy);
            }
        }

        homePage.conditionalLogicRules = [];
        if ((formToCopy.conditionalLogicRules != null) && (formToCopy.conditionalLogicRules.length > 0)) {
            for (let exprIndex: number = 0; exprIndex < formToCopy.conditionalLogicRules.length; exprIndex++) {
                let formFieldExpression: FormFieldExpression = formToCopy.conditionalLogicRules[exprIndex];

                let exprClone: FormFieldExpression = <FormFieldExpression>formFieldExpression.clone();
                homePage.conditionalLogicRules.push(exprClone);
            }
        }

        return homePage;
    }
}
